export const LIST_PARTNER_REQUEST = 'LIST_PARTNER_REQUEST'
export const LIST_PARTNER_SUCCESS = 'LIST_PARTNER_SUCCESS'
export const LIST_PARTNER_FAIL = 'LIST_PARTNER_FAIL'

export const LIST_PARTNER_SUMMARY_REQUEST = 'LIST_PARTNER_SUMMARY_REQUEST'
export const LIST_PARTNER_SUMMARY_SUCCESS = 'LIST_PARTNER_SUMMARY_SUCCESS'
export const LIST_PARTNER_SUMMARY_FAIL = 'LIST_PARTNER_SUMMARY_FAIL'

export const RESET_LIST_PARTNER_SUMMARY = 'RESET_LIST_PARTNER_SUMMARY'

export const CREATE_PARTNER_REQUEST = 'CREATE_PARTNER_REQUEST'
export const CREATE_PARTNER_SUCCESS = 'CREATE_PARTNER_SUCCESS'
export const CREATE_PARTNER_FAIL = 'CREATE_PARTNER_FAIL'

export const DETAIL_PARTNER_REQUEST = 'DETAIL_PARTNER_REQUEST'
export const DETAIL_PARTNER_SUCCESS = 'DETAIL_PARTNER_SUCCESS'
export const DETAIL_PARTNER_FAIL = 'DETAIL_PARTNER_FAIL'

export const DETAIL_PARTNER_RESET = 'DETAIL_PARTNER_RESET'

export const UPDATE_PARTNER_REQUEST = 'UPDATE_PARTNER_REQUEST'
export const UPDATE_PARTNER_SUCCESS = 'UPDATE_PARTNER_SUCCESS'
export const UPDATE_PARTNER_FAIL = 'UPDATE_PARTNER_FAIL'

export const DELETE_PARTNER_REQUEST = 'DELETE_PARTNER_REQUEST'
export const DELETE_PARTNER_SUCCESS = 'DELETE_PARTNER_SUCCESS'
export const DELETE_PARTNER_FAIL = 'DELETE_PARTNER_FAIL'

export const LIST_PARTNER_BRANCH_REQUEST = 'LIST_PARTNER_BRANCH_REQUEST'
export const LIST_PARTNER_BRANCH_SUCCESS = 'LIST_PARTNER_BRANCH_SUCCESS'
export const LIST_PARTNER_BRANCH_FAIL = 'LIST_PARTNER_BRANCH_FAIL'

export const LIST_PARTNER_BRANCH_SUMMARY_REQUEST = 'LIST_PARTNER_BRANCH_SUMMARY_REQUEST'
export const LIST_PARTNER_BRANCH_SUMMARY_SUCCESS = 'LIST_PARTNER_BRANCH_SUMMARY_SUCCESS'
export const LIST_PARTNER_BRANCH_SUMMARY_FAIL = 'LIST_PARTNER_BRANCH_SUMMARY_FAIL'

export const RESET_LIST_PARTNER_BRANCH_SUMMARY = 'RESET_LIST_PARTNER_BRANCH_SUMMARY'

export const CREATE_PARTNER_BRANCH_REQUEST = 'CREATE_PARTNER_BRANCH_REQUEST'
export const CREATE_PARTNER_BRANCH_SUCCESS = 'CREATE_PARTNER_BRANCH_SUCCESS'
export const CREATE_PARTNER_BRANCH_FAIL = 'CREATE_PARTNER_BRANCH_FAIL'

export const DETAIL_PARTNER_BRANCH_REQUEST = 'DETAIL_PARTNER_BRANCH_REQUEST'
export const DETAIL_PARTNER_BRANCH_SUCCESS = 'DETAIL_PARTNER_BRANCH_SUCCESS'
export const DETAIL_PARTNER_BRANCH_FAIL = 'DETAIL_PARTNER_BRANCH_FAIL'

export const UPDATE_PARTNER_BRANCH_REQUEST = 'UPDATE_PARTNER_BRANCH_REQUEST'
export const UPDATE_PARTNER_BRANCH_SUCCESS = 'UPDATE_PARTNER_BRANCH_SUCCESS'
export const UPDATE_PARTNER_BRANCH_FAIL = 'UPDATE_PARTNER_BRANCH_FAIL'

export const DELETE_PARTNER_BRANCH_REQUEST = 'DELETE_PARTNER_BRANCH_REQUEST'
export const DELETE_PARTNER_BRANCH_SUCCESS = 'DELETE_PARTNER_BRANCH_SUCCESS'
export const DELETE_PARTNER_BRANCH_FAIL = 'DELETE_PARTNER_BRANCH_FAIL'

export const SUMMARY_PAYMENT_OPTION_REQUEST = 'SUMMARY_PAYMENT_OPTION_REQUEST'
export const SUMMARY_PAYMENT_OPTION_SUCCESS = 'SUMMARY_PAYMENT_OPTION_SUCCESS'
export const SUMMARY_PAYMENT_OPTION_FAIL = 'SUMMARY_PAYMENT_OPTION_FAIL'

export const LIST_PARTNER_INVOICE_ADDRESS_REQUEST = 'LIST_PARTNER_INVOICE_ADDRESS_REQUEST'
export const LIST_PARTNER_INVOICE_ADDRESS_SUCCESS = 'LIST_PARTNER_INVOICE_ADDRESS_SUCCESS'
export const LIST_PARTNER_INVOICE_ADDRESS_FAIL = 'LIST_PARTNER_INVOICE_ADDRESS_FAIL'

export const CREATE_PARTNER_INVOICE_ADDRESS_REQUEST = 'CREATE_PARTNER_INVOICE_ADDRESS_REQUEST'
export const CREATE_PARTNER_INVOICE_ADDRESS_SUCCESS = 'CREATE_PARTNER_INVOICE_ADDRESS_SUCCESS'
export const CREATE_PARTNER_INVOICE_ADDRESS_FAIL = 'CREATE_PARTNER_INVOICE_ADDRESS_FAIL'

export const DETAIL_PARTNER_INVOICE_ADDRESS_REQUEST = 'DETAIL_PARTNER_INVOICE_ADDRESS_REQUEST'
export const DETAIL_PARTNER_INVOICE_ADDRESS_SUCCESS = 'DETAIL_PARTNER_INVOICE_ADDRESS_SUCCESS'
export const DETAIL_PARTNER_INVOICE_ADDRESS_FAIL = 'DETAIL_PARTNER_INVOICE_ADDRESS_FAIL'
export const RESET_DETAIL_PARTNER_INVOICE_ADDRESS = 'RESET_DETAIL_PARTNER_INVOICE_ADDRESS'

export const UPDATE_PARTNER_INVOICE_ADDRESS_REQUEST = 'UPDATE_PARTNER_INVOICE_ADDRESS_REQUEST'
export const UPDATE_PARTNER_INVOICE_ADDRESS_SUCCESS = 'UPDATE_PARTNER_INVOICE_ADDRESS_SUCCESS'
export const UPDATE_PARTNER_INVOICE_ADDRESS_FAIL = 'UPDATE_PARTNER_INVOICE_ADDRESS_FAIL'

export const DELETE_PARTNER_INVOICE_ADDRESS_REQUEST = 'DELETE_PARTNER_INVOICE_ADDRESS_REQUEST'
export const DELETE_PARTNER_INVOICE_ADDRESS_SUCCESS = 'DELETE_PARTNER_INVOICE_ADDRESS_SUCCESS'
export const DELETE_PARTNER_INVOICE_ADDRESS_FAIL = 'DELETE_PARTNER_INVOICE_ADDRESS_FAIL'

export const LIST_PARTNER_INVOICE_ADDRESS_SUMMARY_REQUEST = 'LIST_PARTNER_INVOICE_ADDRESS_SUMMARY_REQUEST'
export const LIST_PARTNER_INVOICE_ADDRESS_SUMMARY_SUCCESS = 'LIST_PARTNER_INVOICE_ADDRESS_SUMMARY_SUCCESS'
export const LIST_PARTNER_INVOICE_ADDRESS_SUMMARY_FAIL = 'LIST_PARTNER_INVOICE_ADDRESS_SUMMARY_FAIL'

export const LIST_PARTNER_DOCUMENT_REQUEST = 'LIST_PARTNER_DOCUMENT_REQUEST'
export const LIST_PARTNER_DOCUMENT_SUCCESS = 'LIST_PARTNER_DOCUMENT_SUCCESS'
export const LIST_PARTNER_DOCUMENT_FAIL = 'LIST_PARTNER_DOCUMENT_FAIL'

export const CREATE_PARTNER_DOCUMENT_REQUEST = 'CREATE_PARTNER_DOCUMENT_REQUEST'
export const CREATE_PARTNER_DOCUMENT_SUCCESS = 'CREATE_PARTNER_DOCUMENT_SUCCESS'
export const CREATE_PARTNER_DOCUMENT_FAIL = 'CREATE_PARTNER_DOCUMENT_FAIL'

export const UPDATE_PARTNER_DOCUMENT_REQUEST = 'UPDATE_PARTNER_DOCUMENT_REQUEST'
export const UPDATE_PARTNER_DOCUMENT_SUCCESS = 'UPDATE_PARTNER_DOCUMENT_SUCCESS'
export const UPDATE_PARTNER_DOCUMENT_FAIL = 'UPDATE_PARTNER_DOCUMENT_FAIL'

export const DELETE_PARTNER_DOCUMENT_REQUEST = 'DELETE_PARTNER_DOCUMENT_REQUEST'
export const DELETE_PARTNER_DOCUMENT_SUCCESS = 'DELETE_PARTNER_DOCUMENT_SUCCESS'
export const DELETE_PARTNER_DOCUMENT_FAIL = 'DELETE_PARTNER_DOCUMENT_FAIL'

export const DOWNLOAD_PARTNER_DOCUMENT_REQUEST = 'DOWNLOAD_PARTNER_DOCUMENT_REQUEST'
export const DOWNLOAD_PARTNER_DOCUMENT_SUCCESS = 'DOWNLOAD_PARTNER_DOCUMENT_SUCCESS'
export const DOWNLOAD_PARTNER_DOCUMENT_FAIL = 'DOWNLOAD_PARTNER_DOCUMENT_FAIL'

export const LIST_PARTNER_DOCUMENT_CLASSIFICATION_REQUEST = 'LIST_PARTNER_DOCUMENT_CLASSIFICATION_REQUEST'
export const LIST_PARTNER_DOCUMENT_CLASSIFICATION_SUCCESS = 'LIST_PARTNER_DOCUMENT_CLASSIFICATION_SUCCESS'
export const LIST_PARTNER_DOCUMENT_CLASSIFICATION_FAIL = 'LIST_PARTNER_DOCUMENT_CLASSIFICATION_FAIL'
